__turbopack_context__.v({
  "className": "megalona_77af4987-module__lLN5aW__className",
  "variable": "megalona_77af4987-module__lLN5aW__variable",
});
